import { render, staticRenderFns } from "./VaButtonToggle.vue?vue&type=template&id=ec0afae2&"
import script from "./VaButtonToggle.vue?vue&type=script&lang=js&"
export * from "./VaButtonToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports